import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { LocationLandingPage } from './LocationLandingPage';

export function MarketLandingPage() {
  const { id } = useParams<{ id: string }>();
  const marketId = Number(id);
  if (!marketId) return <Navigate to="/dashboard" replace />;
  return <LocationLandingPage mode="market" id={marketId} />;
}
